/* Scroll reveal for the blog index.
 *
 * Vanilla and standalone so it ports to the theme unchanged, as
 * {{ 'blog-reveal.js' | asset_url | script_tag }} — no imports, no build step.
 * Everything carrying [data-reveal] starts hidden in CSS and is released once,
 * the first time it comes near the viewport.
 */
/* Two forms of the attribute, as on About Us /2:
 *
 *   data-reveal=""            fade this element up when it arrives (`is-in`)
 *   data-reveal="<selector>"  add `is-arrived` to this SECTION once the element
 *                             the selector picks comes into view
 *
 * The second is what the split headings key off: the lines live inside the
 * head, but the class that releases them has to land on an ancestor, so the
 * section carries it and names its own trigger.
 */
/* WHEN this runs matters more than what it does. The page is large — every
 * article is in the markup — and the CSS hides each [data-reveal=""] card from
 * the first paint until this script releases it. Loaded at the end of the
 * document, it would not run until the whole thing had parsed, and Safari in
 * particular showed the section titles seconds before their cards. So the
 * page includes it as a plain blocking <script> straight after the category
 * rows: it executes mid-parse, the moment those rows exist, and the cards in
 * view are released at once. Anything parsed later (the "All articles" head)
 * is picked up by the second pass at DOMContentLoaded — scan() only ever
 * observes an element once, so running it twice is safe.
 */
(function () {
  var reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var hasIO = typeof IntersectionObserver === "function";
  var release = function (section) { section.classList.add("is-arrived"); };

  var aio = hasIO && new IntersectionObserver(
    function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        release(e.target.__section || e.target);
        aio.unobserve(e.target);
      });
    },
    // The same depth the fade below trips at, so every entrance on the page
    // arrives at the same point in the scroll.
    { rootMargin: "0px 0px -8% 0px" }
  );

  var io = hasIO && new IntersectionObserver(
    function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add("is-in");
        io.unobserve(e.target); // one-way: nothing re-hides on the way back up
      });
    },
    /* Fires a little before the element arrives, so the motion has finished by
       the time it is properly in view rather than starting there. */
    { rootMargin: "0px 0px -8% 0px", threshold: 0.05 }
  );

  function scan() {
    var anchored = document.querySelectorAll("[data-reveal]:not([data-reveal=''])");
    for (var a = 0; a < anchored.length; a++) {
      var section = anchored[a];
      if (section.__seen) continue;
      section.__seen = true;
      var anchor = section.querySelector(section.getAttribute("data-reveal"));
      if (!anchor || !hasIO) { release(section); continue; }
      anchor.__section = section;
      aio.observe(anchor);
    }

    var items = document.querySelectorAll("[data-reveal='']");
    for (var i = 0; i < items.length; i++) {
      var el = items[i];
      if (el.__seen) continue;
      el.__seen = true;
      /* Reduced motion: show immediately and never observe. The CSS already
         neutralises the transition, but leaving items hidden until an observer
         fires would be worse than not animating at all. */
      if (reduced || !hasIO) el.classList.add("is-in");
      else io.observe(el);
    }
  }

  scan();
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", scan);
})();
